// extracted by mini-css-extract-plugin
export default {"wrapper":"_n-z","reviewFormSuccess":"ao-z","header":"bo-z","message":"co-z","paragraph":"do-z","lottieContainer":"eo-z"};